import { IOrdersDashboardSummaryQuery, IPagination } from 'dto/orders.dto'

/** Параметры серверного списка заказов */
export interface IAdminOrdersListQuery extends IOrdersDashboardSummaryQuery {
  limit?: number
  offset?: number
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
}

/**
 * Собирает query для GET /orders/admin-list и dashboard-summary.
 * @param query — фильтры / пагинация / сортировка
 */
export const buildAdminOrdersListParams = (
  query?: IAdminOrdersListQuery,
): Record<string, string | number> | undefined => {
  if (!query) {
    return undefined
  }

  const params: Record<string, string | number> = {}

  if (typeof query.limit === 'number' && query.limit > 0) {
    params.limit = query.limit
  }
  if (typeof query.offset === 'number' && query.offset >= 0) {
    params.offset = query.offset
  }
  if (
    typeof query.pizzeria_id === 'number' &&
    !Number.isNaN(query.pizzeria_id)
  ) {
    params.pizzeria_id = query.pizzeria_id
  }
  if (typeof query.status_id === 'number' && !Number.isNaN(query.status_id)) {
    params.status_id = query.status_id
  }
  if (query.payment_type?.trim?.()) {
    params.payment_type = query.payment_type.trim()
  }
  if (query.payment_status?.trim?.()) {
    params.payment_status = query.payment_status.trim()
  }
  if (query.sortBy?.trim?.()) {
    params.sortBy = query.sortBy.trim()
  }
  if (query.sortOrder) {
    params.sortOrder = query.sortOrder
  }

  return Object.keys(params).length > 0 ? params : undefined
}

/**
 * Собирает query списка из redux filter + pagination + sort.
 */
export const buildAdminOrdersListQueryFromState = (params: {
  filter: {
    pizzeria_id: number | null
    status_id: number | null
    paymentType: string | null
    paymentStatus: string | null
  }
  pagination: IPagination
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
}): IAdminOrdersListQuery => {
  const { filter, pagination, sortBy, sortOrder } = params
  return {
    limit: pagination.rowsPerPage,
    offset: pagination.page * pagination.rowsPerPage,
    pizzeria_id: filter.pizzeria_id,
    status_id: filter.status_id,
    payment_type: filter.paymentType,
    payment_status: filter.paymentStatus,
    sortBy: sortBy || 'id',
    sortOrder: sortOrder === 'asc' ? 'ASC' : 'DESC',
  }
}
